import React, { FC, useEffect } from 'react'

import Master from './Master'
import Detail from './Detail'

import { setLatestPage } from '../../store/pages-management/actions'

import './styles.scss'
import { requestSettings } from '../../store/settings/actions'
import { eraseCookie, readCookie } from '../../utils/cookies'
import { useDispatch } from 'react-redux'

const PagesManagement: FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(requestSettings())
    const latestPage = readCookie('page')
    if (latestPage) {
      dispatch(setLatestPage(latestPage))
      eraseCookie('page')
    }
  }, [dispatch])

  return (
    <div className="pages styles">
      <div className="columns">
        <Master />
        <div className="column">
          <Detail />
        </div>
      </div>
    </div>
  )
}
export default PagesManagement
